// Backend field-name prefixes for the document-query grid. The document type
// selects which prefix the query fields carry; the quirky values
// ('document_values' for OFFER, leading underscores on some *_VALUES prefixes)
// mirror the backend contract and must not be "corrected".

const TYPE_PREFIX = {
  OFFER: 'offer',
  SALES_ORDER: 'sales_order',
  BLANKET_ORDER: 'blanket_order',
  INVOICE: 'invoice',
  WORK_ORDER: 'work_order',
  COMMISSION_NOTE: 'commission_note',
  SALES_VOUCHER: 'sales_voucher',
  DELIVERY_NOTE: 'delivery_note',
  ROUTING_SLIP: 'routing_slip',
} as const;

const VALUES_PREFIX = {
  OFFER: 'document_values',
  SALES_ORDER: '_order_values',
  BLANKET_ORDER: 'blanket_order_values',
  INVOICE: 'invoice_values',
  WORK_ORDER: '_work_order_values',
  COMMISSION_NOTE: 'commission_note_values',
  SALES_VOUCHER: 'sales_voucher_values',
  DELIVERY_NOTE: 'delivery_note_values',
  ROUTING_SLIP: 'routing_slip_values',
} as const;

/** The query-field prefix for a document type. Invoice sub-types and both
    delivery-note variants share a base type; anything else falls back to the
    sales-order prefix. */
export function getDocumentQueryTypePrefix(documentType?: string): string {
  switch (documentType) {
    case 'OFFER':
      return TYPE_PREFIX.OFFER;
    case 'BLANKET_ORDER':
      return TYPE_PREFIX.BLANKET_ORDER;
    case 'DELIVERY_NOTE':
      return TYPE_PREFIX.DELIVERY_NOTE;
    case 'INVOICE':
    case 'CASH_SALE_INVOICE':
    case 'CREDIT_INVOICE':
      return TYPE_PREFIX.INVOICE;
    case 'WORK_ORDER':
      return TYPE_PREFIX.WORK_ORDER;
    case 'COMMISSION_NOTE':
      return TYPE_PREFIX.COMMISSION_NOTE;
    case 'SALES_VOUCHER':
      return TYPE_PREFIX.SALES_VOUCHER;
    case 'ROUTING_SLIP':
      return TYPE_PREFIX.ROUTING_SLIP;
    case 'MATERIAL_DELIVERY_NOTE':
    case 'CONSOLIDATED_MEASUREMENT_REPORT':
      return TYPE_PREFIX.DELIVERY_NOTE;
    default:
      return TYPE_PREFIX.SALES_ORDER;
  }
}

/** The query-VALUES prefix for a document type (same grouping as
    getDocumentQueryTypePrefix). */
export function getDocumentQueryValuesPrefix(documentType?: string): string {
  switch (documentType) {
    case 'OFFER':
      return VALUES_PREFIX.OFFER;
    case 'BLANKET_ORDER':
      return VALUES_PREFIX.BLANKET_ORDER;
    case 'DELIVERY_NOTE':
      return VALUES_PREFIX.DELIVERY_NOTE;
    case 'INVOICE':
    case 'CASH_SALE_INVOICE':
    case 'CREDIT_INVOICE':
      return VALUES_PREFIX.INVOICE;
    case 'WORK_ORDER':
      return VALUES_PREFIX.WORK_ORDER;
    case 'COMMISSION_NOTE':
      return VALUES_PREFIX.COMMISSION_NOTE;
    case 'SALES_VOUCHER':
      return VALUES_PREFIX.SALES_VOUCHER;
    case 'ROUTING_SLIP':
      return VALUES_PREFIX.ROUTING_SLIP;
    case 'MATERIAL_DELIVERY_NOTE':
    case 'CONSOLIDATED_MEASUREMENT_REPORT':
      return VALUES_PREFIX.DELIVERY_NOTE;
    default:
      return VALUES_PREFIX.SALES_ORDER;
  }
}
